import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";

Vue.use(Router);

// 导入页面组件
const Login = () => import("@/views/login/Login.vue");
const Layout = () => import("@/layout/Layout.vue");
const Home = () => import("@/views/home/Home.vue");
const TransportService = () => import("@/views/transportService/TransportService.vue");
const BicyclePlugins = () => import("@/views/bicycle/bicyclePlugins.vue");
const NotFound = () => import("@/views/404/NotFound.vue");
const HistoricalTrajectory = () => import("@/views/transportService/historicalTrajectory.vue");
const HistoricalTrajectoryNew = () => import("@/views/transportService/historicalTrajectoryNew.vue");
const BicyclePluginsMV = () => import("@/views/bicycle/bicyclePluginsMV.vue");
const BicyclePluginsMVGarage = () => import("@/views/bicycle/bicyclePluginsMVGarage.vue");
const aMustPassPlace = () => import("@/views/aMustPassPlace/aMustPassPlace.vue");
const TrackIndex = () => import("@/views/track/index.vue");
const Trajectory = () => import("@/views/track/trajectory.vue");
const TransportServiceIndex = () => import("@/views/transportService/index.vue");
const HistoricalPlugins = () => import("@/views/transportService/historicalPlugIn.vue");
const StandalonePlugin = () => import("@/views/transportService/standalonePlugIn.vue");
const TransferPlugin = () => import("@/views/transportService/transferPlugln.vue");
const HazardousChemicals = () => import("@/views/hazardousChemicals/index.vue");
const History = () => import("@/views/business/history.vue");
const Plan = () => import("@/views/business/plan.vue");
const Position = () => import("@/views/business/position.vue");
const Fence = () => import("@/views/business/fence.vue");
// 路由规则
const routes = [
  {
    path: "/",
    redirect: "/home", // 默认跳首页
  },
  {
    path: "/login",
    component: Login,
    hidden: true, // 不在侧边栏显示
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "首页", icon: "el-icon-s-home" },
    children: [
      {
        path: "home",
        name: "HomeName",
        component: Home,
        meta: { title: "首页", icon: "el-icon-s-data" },
      },
    ],
  },
  {
    path: "/index",
    component: Layout,
    redirect: "/index/hazardousChemicals",
    meta: { title: "危化管理", icon: "el-icon-s-home" },
    children: [
      {
        path: "hazardousChemicals",
        name: "HazardousChemicalsName",
        component: HazardousChemicals,
        meta: { title: "危化轨迹", icon: "el-icon-s-data" },
      }
    ],
  }, {
    path: "/",
    component: Layout,
    meta: { title: "业务查询", icon: "el-icon-s-home" },
    children: [
      {
        path: "history",
        name: "HistoryName",
        component: History,
        meta: { title: "历史轨迹", icon: "el-icon-s-data" },
      },      
      {
        path: "plan",
        name: "PlanName",
        component: Plan,
        meta: { title: "运输规划", icon: "el-icon-s-data" },
      },      
      {
        path: "position",
        name: "PositionName",
        component: Position,
        meta: { title: "运输节点", icon: "el-icon-s-data" },
      },      
      {
        path: "fence",
        name: "FenceName",
        component: Fence,
        meta: { title: "围栏管理", icon: "el-icon-s-data" },
      }
    ],
  },
  // 单独的运输服务页面（无侧边栏）
  {
    path: "/standalone-transport",//轨迹插件
    component: TransportService,
    name: "StandaloneTransportService",
    hidden: true,
  },
  {
    path: "/standalone-historicalTrajectory",//历史轨迹插件
    component: HistoricalTrajectory,
    name: "StandaloneHistoricalTrajectory",
    hidden: true,
  },
  {
    path: "/standalone-bicycle",//单车加多车管理
    component: BicyclePlugins,
    name: "StandaloneBicycle",
    hidden: true,
  },
  {
    path: "/standalone-historicalTrajectory-new",//历史轨迹后台使用
    component: HistoricalTrajectoryNew,
    name: "StandaloneHistoricalTrajectoryNew",
    hidden: true,
  }, {
    path: "/bicycle-plugins-mv",//多车管理插件
    component: BicyclePluginsMV,
    name: "StandaBicyclePluginsMV",
    hidden: true,
  }, {
    path: "/bicycle-plugins-mv-garage",//多车管理后台使用
    component: BicyclePluginsMVGarage,
    name: "StandaBicyclePluginsMVGarage",
    hidden: true,
  }, {
    path: "/standalone-a-must-pass-place",//围栏管理
    component: aMustPassPlace,
    name: "AMustPassPlaceName",
    hidden: true,
  },
  {
    path: "/standalone-track",//模拟轨迹路线播放
    component: TrackIndex,
    name: "StandaloneTrackIndex",
    hidden: true,
  }, {
    path: "/standalone-trajectory",//模拟轨迹路线播放2
    component: Trajectory,
    name: "StandaloneTrajectory",
    hidden: true,
  }, {
    path: "/standalone-transport-service-index",//轨迹新页面
    component: TransportServiceIndex,
    name: "StandaloneTransportServiceIndex",
    hidden: true,
  }, {
    path: "/standalone-historical-plugins",//历史轨迹插件
    component: HistoricalPlugins,
    name: "StandaloneHistoricalPlugins",
    hidden: true,
  },
  {
    path: "/standalone-standalone-plugin",//轨迹插件
    component: StandalonePlugin,
    name: "StandaloneStandalonePlugin",
    hidden: true,
  },
  {
    path: "/standalone-transfer-plugin",//运输中转插件
    component: TransferPlugin,
    name: "StandaloneTransferPlugin",
    hidden: true,
  },
  {
    path: "/404",
    component: NotFound,
    name: "NotFoundPage",
    hidden: true,
  },
  {
    path: "*",
    component: NotFound,
    hidden: true,
  },
];

const router = new Router({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 检查URL中是否有p和type参数，如果有则跳转到对应页面
  const urlParams = new URLSearchParams(window.location.search);
  const pParam = urlParams.get("p");
  const typeParam = urlParams.get("type");
  if (pParam && typeParam) {
    // 如果有p和type参数，且当前路径是根路径，则跳转到独立的运输服务页面
    if (pParam && typeParam == 5 && (to.path === "/home" || to.path === "/login" || to.path === "/")) {
      localStorage.setItem("token", pParam);
      next("/standalone-standalone-plugin");
      return;
    } else if (pParam && (typeParam == 3 || typeParam == 6) && (to.path === "/home" || to.path === "/login" || to.path === "/")) {

      localStorage.setItem("token", pParam);
      next("/standalone-historical-plugins");
      return;
    } else if (pParam && typeParam == 1 && (to.path === "/home" || to.path === "/login" || to.path === "/")) {
      localStorage.setItem("token", pParam);
      next("/standalone-bicycle");
      return;
    } else if (pParam && typeParam == 2 && (to.path === "/home" || to.path === "/login" || to.path === "/")) {
      localStorage.setItem("token", pParam);
      next("/standalone-a-must-pass-place");
      return;
    } else if (pParam && typeParam == 4 && (to.path === "/home" || to.path === "/login" || to.path === "/")) {
      localStorage.setItem("token", pParam);
      next("/standalone-transfer-plugin");
      return;
    } else if (
      pParam &&
      (to.path === "/home" || to.path === "/login" || to.path === "/") &&
      !(typeParam == 1 || typeParam == 3 || typeParam == 5 || typeParam == 6 || typeParam == 2 || typeParam == 4)
    ) {
      // 带插件参数 p 但 type 非支持的独立页类型：不走路由首页/登录逻辑，直接 404
      next("/404");
      return;
    }
    next();
  } else {
    if (to.path == '/standalone-transport-service-index' || to.path == '/bicycle-plugins-mv-garage') {
      next();
    } else {
      const token = localStorage.getItem("token_bearer");
      // 未登录且访问非登录页，跳转登录（404 可匿名访问，避免插件错误 type 时再被踢回登录）
      if (!token && to.path !== "/login" && to.path !== "/404") {
        next("/login");
      } else if (token && to.path === "/login") {
        // 已登录访问登录页，跳首页
        next("/home");
      } else {
        next();
      }
    }

  }


});

router.afterEach(() => {
  NProgress.done();
});

export default router;
